var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column text-center pa-4"},[_c('m-mentoring-availability',{model:{value:(_vm.mentoring),callback:function ($$v) {_vm.mentoring=$$v},expression:"mentoring"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }